module.exports = __webpack_public_path__ + "img/xUSDT.9d67538d.svg";